import React from 'react';

export const FilasDinamicas = ({ filas = [] }) => {
    
    const filasVisibles = filas.filter(fila => fila.mostrar !== false);

    if (filasVisibles.length === 0) return null;

    return (
        <div className="w-full overflow-x-auto mt-1">
            <table className="w-full text-left border-collapse">
                <tbody>
                    {filasVisibles.map((fila, index) => {
                        // Respetamos si el valor ya viene formateado como JSX (ej: la lista de la comisión)
                        // o si es un string común. Si está vacío, ponemos 'No registrado'
                        const contenidoValor = fila.valor !== undefined && fila.valor !== null ? fila.valor : 'No registrado';
                        const textoOriginal = typeof contenidoValor === 'string' ? contenidoValor : '';

                        return (
                            <tr key={index} className="text-sm text-slate-700">
                                {/* Celda Etiqueta */}
                                {/* CAMBIO: Agregamos !border-t-0 con el ! para ganarle al dotted del index.css */}
                                <td className={`!py-2 pr-4 text-slate-500 font-medium text-xs sm:text-sm !border-t-0 ${
                                    index < filasVisibles.length - 1 
                                        ? '!border-b !border-slate-100' 
                                        : '!border-b-0'
                                }`}>
                                    {fila.etiqueta}
                                </td>
                                
                                {/* Celda Valor */}
                                {/* CAMBIO 1: Agregamos !border-t-0 para neutralizar el CSS global */}
                                {/* CAMBIO 2: Volvemos a font-bold para unificar el impacto visual de las respuestas */}
                                <td 
                                    className={`!py-2 font-bold text-slate-800 text-right sm:text-left max-w-[50ch] truncate !border-t-0 ${
                                        index < filasVisibles.length - 1 
                                            ? '!border-b !border-slate-100' 
                                            : '!border-b-0'
                                    }`}
                                    title={textoOriginal}
                                >
                                    {contenidoValor}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};